module.exports = __webpack_public_path__ + "static/media/dry-fruits-nuts.92c701cd.webp";